// Alias
import ItemLabel from '../utilities/menu-list/item-label';

export default ItemLabel;
